import BallDropAnimation from "../components/landing/balldrop";
import Footer from "../components/landing/footer";
import "animate.css";
import { useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import logo from "../assets/tweezers.svg";
import f1 from "../assets/f1.svg";
import f2 from "../assets/f2.svg";
import f3 from "../assets/f3.svg";
import f4 from "../assets/f4.svg";
import android from "../assets/android.svg";
// import appstore from "../assets/appstore.svg"

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      return;
    }

    const decodedToken = jwtDecode(token);

    if (decodedToken.exp * 1000 < Date.now()) {
      localStorage.removeItem("token");
      return;
    } else {
      navigate("/account/home");
      return;
    }
  }, [navigate]);

  return (
    <div className="bg-primary">
      <BallDropAnimation />

      <div className="relative w-full md:min-h-screen bg-cover bg-center h-[70pc] bg-[url('/src/assets/mobile.jpg')] md:bg-[url('/src/assets/hero.jpg')] overflow-x-hidden">
        <div className="absolute top-8 px-6 md:px-24">
          <img
            src={logo}
            alt="Logo"
            className="p-2 animate__animated animate__lightSpeedInLeft"
          />
        </div>

        <div className="flex flex-col items-center md:items-start justify-center text-left px-6 md:px-16 lg:px-28 relative top-40 md:top-52">
          <h1 className="animate__animated animate__fadeInDown text-3xl md:text-[45px] text-center md:text-left font-bold text-white">
            <span className="text-primary animate-pulse">Tweezers! - </span>
            Precision
            <br />
            In Every Prediction
          </h1>

          <p className="animate__animated animate__fadeInUp hidden md:block text-base sm:text-lg text-gray-300 mt-4 max-w-2xl text-center md:text-left">
            Tweezers is your go-to football betting prediction platform.{" "}
            <span className="block">
              Get expert insights, smart analysis, and maximize your <br></br>{" "}
              winning chances.
            </span>
          </p>

          <p className="animate__animated animate__fadeInUp  md:hidden block text-[14px] sm:text-sm  text-gray-300 mt-4 max-w-2xl text-center md:text-left">
            Tweezers is your go-to football betting prediction platform. Get
            expert insights, smart analysis, and maximize your winning chances.
          </p>

          <div className="flex flex-col sm:flex-row gap-10 mt-12 sm:mt-18">
            <Link to="/auth/signin">
              <div className="px-8 py-6 sm:px-8 sm:py-16 text-white font-bold text-xl sm:text-2xl rounded-2xl backdrop-blur-lg bg-black/50 border border-white/20 shadow-lg hover:bg-white/20 transition-all">
                <span className="text-primary">Start Predicting</span>
                <span className="text-sm font-medium text-accent block mt-4">
                  Join for free and get expert-backed
                  <br />
                  football betting insights. Stay ahead of the game!
                </span>
              </div>
            </Link>

            <div className="px-8 py-6 sm:px-8 sm:py-7 text-white font-bold text-xl sm:text-2xl rounded-2xl backdrop-blur-lg bg-gray-700/10 border border-white/20 shadow-lg hover:bg-white/20 transition-all">
              <span className="text-primary">Get the Tweezers App</span>
              <div className="flex flex-col sm:flex-row gap-4 mt-6">
                <a
                  href="https://drive.google.com/file/d/1tWDTU9YWVtTz2obvCwn7qug0lLr-jehG/view?usp=share_link"
                  download="Tweezers-App.apk"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group relative px-6 py-4 bg-gradient-to-r from-primary to-primary/90 text-white rounded-xl hover:from-primary/90 hover:to-primary hover:scale-105 transition-all duration-300 font-semibold text-base flex items-center justify-center gap-3 shadow-xl hover:shadow-2xl hover:shadow-primary/25 border border-primary/20 flex-1"
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-white/10 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <img
                    src={android}
                    alt="Android"
                    className="w-6 h-6 relative z-10 filter brightness-0 invert"
                  />
                  <div className="relative z-10 flex flex-col items-start">
                    <span className="text-xs opacity-90">Get the</span>
                    <span className="text-base font-bold -mt-1 whitespace-nowrap">
                      Android App
                    </span>
                  </div>
                </a>

                {/* <button 
                    className="group relative px-6 py-4 bg-gradient-to-r from-slate-800 to-slate-700 text-white rounded-xl opacity-60 cursor-not-allowed font-semibold text-base flex items-center justify-center gap-3 shadow-lg border border-slate-600/30 flex-1"
                    disabled
                  >
                    <img src={appstore} alt="App Store" className="w-6 h-6 filter brightness-0 invert" />
                    <div className="flex flex-col items-start">
                      <span className="text-xs opacity-75">Download from</span>
                      <span className="text-base font-bold -mt-1">App Store</span>
                    </div>
                  </button> */}
              </div>
            </div>
          </div>

          {/* Features Section */}
          <div className="flex flex-wrap justify-center gap-12 mt-16 sm:mt-30">
            <div className="flex flex-col items-center gap-3 justify-center">
              <span>
                <img
                  className="h-10 w-10 sm:h-18 sm:w-18"
                  src={f1}
                  alt="features"
                />
              </span>
              <span className="text-sm  text-white text-center font-light ">
                AI-Powered <br /> Predictions
              </span>
            </div>

            {/* 2 */}
            <div className="flex flex-col items-center gap-3 justify-center">
              <span>
                <img
                  className="h-10 w-10 sm:h-18 sm:w-18"
                  src={f2}
                  alt="features"
                />
              </span>
              <span className="text-sm  text-white text-center font-light ">
                Data-Driven
                <br />
                Insights
              </span>
            </div>

            {/* 3 */}
            <div className="flex flex-col items-center gap-3 justify-center">
              <span>
                <img
                  className="h-10 w-10 sm:h-18 sm:w-18"
                  src={f3}
                  alt="features"
                />
              </span>
              <span className="text-sm  text-white text-center font-light ">
                Fast &<br /> Reliable
              </span>
            </div>

            {/* 4 */}
            <div className="flex flex-col items-center gap-3 justify-center ">
              <span>
                <img
                  className="h-10 w-10 sm:h-18 sm:w-18"
                  src={f4}
                  alt="features"
                />
              </span>
              <span className="text-sm text-white text-center font-light ">
                Smarter Betting
                <br />
                Strategies
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="absolute left-0 right-0">
        <Footer />
      </div>
    </div>
  );
};

export default Home;
